// #region Cookie Utility Functions

/**
 * Retrieve a cookie value by its key.
 * @param {string} key - The name of the cookie to retrieve.
 * @returns {string|null} The value of the cookie if it exists, otherwise null.
 */
const getCookie = key => {
	const b = document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`);
	return b ? b.pop() : null;
};

/**
 * Invalidates a cookie by setting its expiration date to a past date.
 * @param {string} key - The name of the cookie to invalidate.
 * @returns {void}
 */
const invalidateCookie = key => {
	const rootDomain = window.location.hostname.split('.').slice(-2).join('.');
	document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${rootDomain};`;
};
// #endregion

// #region User Country Functions
/**
 * Retrieve the user's country based on the 'GEO_COUNTRY' cookie.
 * @returns {string|null} The value of the 'GEO_COUNTRY' cookie if it exists, otherwise null.
 */
export function getUserCountryBasedOnGeo() {
	const cookie = getCookie('GEO_COUNTRY');
	return cookie || null;
}
// #endregion

// #region Auth Cookie Functions
/**
 * Name of the auth cookie used to store authentication tokens.
 * @type {string}
 */
const authCookieName = 'gynzy-com_session';

/**
 * Retrieves the auth cookie from the document cookies.
 * @returns {Object|null} The auth cookie object if it exists, otherwise null.
 */
export function getAuthCookie() {
	const authCookie = getCookie(authCookieName);
	try {
		const decodedCookie = JSON.parse(decodeURIComponent(authCookie));
		return decodedCookie.authenticated;
	} catch (e) {
		return null;
	}
}

/**
 * Invalidates the auth cookie
 * @returns {void}
 */
export function invalidateAuthCookie() {
	invalidateCookie(authCookieName);
}
// #endregion
